import { RG_TYPE as r } from "@project-rouge/rg-core";
import { countNorthFacingUnits as e } from "../total-metrics/index.js";
import { getRgObjectsAtLevel as n } from "../../../utils/rg-util/index3.js";
const g = (t, o) => e(n(t, r.Apartment, o));
export {
  g as getLevelCountNorthFacingUnits
};
//# sourceMappingURL=index13.js.map
